import {NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule,HTTP_INTERCEPTORS} from '@angular/common/http';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LocationStrategy, HashLocationStrategy} from '@angular/common';
import {AfmComponentsModule} from 'afm-components';
import {BreadcrumbModule} from 'primeng/breadcrumb';
import {ButtonModule} from 'primeng/button';
import {CalendarModule} from 'primeng/calendar';
import {CheckboxModule} from 'primeng/checkbox';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {DialogModule} from 'primeng/dialog';
import {DropdownModule} from 'primeng/dropdown';
import {FieldsetModule} from 'primeng/fieldset';
import {FileUploadModule} from 'primeng/fileupload';
import {InputSwitchModule} from 'primeng/inputswitch';
import {InputTextModule} from 'primeng/inputtext';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {ListboxModule} from 'primeng/listbox';
import {MegaMenuModule} from 'primeng/megamenu';
import {MenuModule} from 'primeng/menu';
import {MenubarModule} from 'primeng/menubar';
import {MessagesModule} from 'primeng/messages';
import {MessageModule} from 'primeng/message';
import {PaginatorModule} from 'primeng/paginator';
import {PasswordModule} from 'primeng/password';
import {RadioButtonModule} from 'primeng/radiobutton';
import {TableModule} from 'primeng/table';
import {TabViewModule} from 'primeng/tabview';
import {ToastModule} from 'primeng/toast';
import {ToolbarModule} from 'primeng/toolbar';
import {TooltipModule} from 'primeng/tooltip';
import {SidebarModule} from 'primeng/sidebar';
import {TagModule} from 'primeng/tag';
import {MessageService} from 'primeng/api';
import {ConfirmationService} from 'primeng/api';

import {AppComponent} from './app.component';
import {AppMainComponent} from './app.main.component';
import {AppConfigComponent} from './app.config.component';
import {AppMenuComponent} from './app.menu.component';
import {AppMenuitemComponent} from './app.menuitem.component';
import {AppInlineMenuComponent} from './app.inlinemenu.component';
import {AppRightMenuComponent} from './app.rightmenu.component';
import {AppBreadcrumbComponent} from './app.breadcrumb.component';
import {AppTopBarComponent} from './app.topbar.component';
import {AppFooterComponent} from './app.footer.component';

import {AppLoginComponent} from './login/app.login.component';
import {ConfigAdminComponent} from './admin/config/config.component';
import {UsersAdminComponent,UserAdminListComponent,UserAdminComponent} from './admin/users/users.component';
import {PartnersComponent,PartnerListComponent,PartnerComponent} from './admin/partners/partners.component';
import {PartnerGroupsComponent,PartnerGroupListComponent,PartnerGroupComponent} from './admin/partner-groups/partner-groups.component';
import {ProcessSComponent,ProcessListComponent,ProcessComponent} from './admin/process/process.component';
import {UsersComponent,UserListComponent,UserComponent} from './users/users.component';
import {RolesComponent, RoleComponent, RoleListComponent} from './roles/roles.component';
import {FormsComponent, FormListComponent, FormComponent} from './forms/form.component';


import {MenuService} from './app.menu.service';
import {AppBreadcrumbService} from './app.breadcrumb.service';

import {HelpComponent} from './help/help.component';
import {ProfileComponent} from './users/profile/profile.component'

import {AuthInterceptor} from './login/auth.interceptor';
import {NgHttpLoaderModule} from 'ng-http-loader';
import { NgxSpinnerModule } from "ngx-spinner";
import {DashBoardComponent} from './dashboard/dashboard.component';
import { JwtModule } from '@auth0/angular-jwt';
import { AppRoutingModule } from './app-routing.module';
import { UsageComponent } from './usage/usage.component';

export function tokenGetterFn() {
    return localStorage.getItem('afm-token');
};

@NgModule({
    declarations: [
        AppComponent,
        AppMainComponent,
        AppConfigComponent,
        AppMenuComponent,
        AppMenuitemComponent,
        AppInlineMenuComponent,
        AppRightMenuComponent,
        AppBreadcrumbComponent,
        AppTopBarComponent,
        AppFooterComponent,
        UsersComponent,
        UserListComponent,
        UserComponent,
        RolesComponent,
        RoleListComponent,
        RoleComponent,
        FormsComponent,
        FormListComponent,
        FormComponent,
        AppLoginComponent,
        DashBoardComponent,
        HelpComponent,
        ProfileComponent,
        UsageComponent,
        UsersAdminComponent,
        UserAdminListComponent,
        UserAdminComponent,
        PartnersComponent,
        PartnerListComponent,
        PartnerComponent,
        PartnerGroupsComponent,
        PartnerGroupListComponent,
        PartnerGroupComponent,
        ProcessSComponent,
        ProcessListComponent,
        ProcessComponent,
        ConfigAdminComponent
    ],
    imports: [
        BrowserModule,
        AfmComponentsModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        HttpClientModule,
        BrowserAnimationsModule,
        SidebarModule,
        TagModule,
        BreadcrumbModule,
        ButtonModule,
        CalendarModule,
        CheckboxModule,
        ConfirmDialogModule,
        DialogModule,
        DropdownModule,
        FieldsetModule,
        FileUploadModule,
        InputSwitchModule,
        InputTextModule,
        InputTextareaModule,
        ListboxModule,
        MegaMenuModule,
        MenuModule,
        MenubarModule,
        MessageModule,
        MessagesModule,
        PaginatorModule,
        PasswordModule,
        RadioButtonModule,
        TableModule,
        TabViewModule,
        ToastModule,
        ToolbarModule,
        TooltipModule,
        NgHttpLoaderModule.forRoot(),
        NgxSpinnerModule,
        JwtModule.forRoot({
            config: {
                tokenGetter: tokenGetterFn
            }
        })
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        {provide: LocationStrategy, useClass: HashLocationStrategy},
        AppBreadcrumbService, MessageService,ConfirmationService, MenuService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
